import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-radiobutton',
  templateUrl: './adc-radiobutton.component.html',
  styleUrls: ['./adc-radiobutton.component.scss'],
  standalone: false
})
export class AdcRadiobuttonComponent {
  @Input('data') data: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  onRadioChange(itemId: string) {
    const checkedItem = this.data.items.find((item: { itemId: string; }) => item.itemId === itemId);
    if (checkedItem) {
      this.valueChange.emit(checkedItem);
    }
  }
}
